<template>
    <div
        class="pdf-page-image"
        v-show="inScrollView"
        :style="elementStyle"
    >
        <canvas ref="canvas"></canvas>

        <slot v-bind="{ loaded }"></slot>
    </div>
</template>
<script>

export default {
    name: 'PdfPageImage',
    props: {
        scale: Number,
        page: Object,
        viewport: Object,
        elementStyle: Object,
        inScrollView: Boolean,
        isScrolling: Boolean,
        watermarkText: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            loaded: false,
            canvas: null,
            image: null
        };
    },
    computed: {
        visibility () {
            return !this.isScrolling && this.inScrollView;
        },
    },
    watch: {
        visibility: {
            handler (nv) {
                nv && this.renderContent();
            },
            immediate: true
        },
        scale: {
            handler() {
                this.updateContent();
            }
        }
    },
    methods: {
        renderContent () {
            if (this.loaded) return;
            const imageLoaded = (image, canvas) => {
                if (!image.complete) return imageLoaded(image, canvas);
                const { actualWidth, actualHeight } = this.doSettingCanvas(image, canvas);
                ctx.drawImage(image, 0, 0, actualWidth, actualHeight);
                this.paintWaterMark(ctx);
                this.loaded = true;
                this.$emit('page-rendered');
                console.timeEnd(`第${this.page.pageNumber}页渲染时间`)
            }

            this.canvas = this.$refs['canvas'];
            console.time(`第${this.page.pageNumber}页渲染时间`)
            const ctx = this.canvas.getContext('2d');
            this.image = new Image();
            this.image.src = this.page.url;
            this.image.crossOrigin = this.page.crossOrigin;

            this.image.onload = imageLoaded.bind(null, this.image, this.canvas);
        },

        /** 更新canvas画布 */
        doSettingCanvas (image, canvas) {
            const { scale } = this;
            const actualWidth = image.width * scale;
            const actualHeight = image.height * scale;
            const ctx = canvas.getContext('2d');

            canvas.style.width = this.elementStyle.width;
            canvas.style.height = this.elementStyle.height;
            canvas.width = actualWidth;
            canvas.height = actualHeight;
            ctx?.clearRect(0, 0, actualWidth, actualHeight);

            return { actualWidth, actualHeight };
        },

        /** 绘制水印 */
        paintWaterMark (ctx) {
            if (!this.watermarkText) return;
            ctx.font = '18px Microsoft YaHei';
            ctx.fillStyle = 'rgba(211, 210, 211, 0.3)';
            for (let i = 0; i < 200; i++) {
                ctx.save();
                ctx.translate(400 * (i % 5), 373 * parseInt((i / 5).toString()));
                ctx.rotate(-(Math.PI * (1 / 4)));
                ctx.fillText(this.watermarkText, 0, 0);
                ctx.restore();
            }
        },

        updateContent () {
            if (!this.loaded || !this.image || !this.canvas) return;
            const { actualWidth, actualHeight } = this.doSettingCanvas(this.image, this.canvas);
            const ctx = this.canvas.getContext('2d');
            ctx.drawImage(this.image, 0, 0, actualWidth, actualHeight);
            this.paintWaterMark(ctx);
        }
    }
};
</script>
